import { useAuth } from 'context/auth-context';
import useSalesPortalAthleteByProfile from 'hooks/salesPortal/useSalesPortalAthleteByProfile';
import { SalesPortalAthleteRetrieve } from 'types';

import { useCheckout } from '../../CheckoutContext';

interface TargetAthleteProfile {
  athleteProfile: SalesPortalAthleteRetrieve | undefined;
  isLoading: boolean;
  athleteProfileId: string | undefined;
}

// The gym athlete record the purchase is for: the signed-in buyer's own athlete when
// buying for themselves, the selected sub-account otherwise (nothing for a new profile).
export default function useTargetAthleteProfile(): TargetAthleteProfile {
  const { session } = useAuth();
  const { form, packageData } = useCheckout();

  const whoIsThisFor = form.values.whoIsThisFor;
  const athleteProfileId = whoIsThisFor === 'myself' ? session?.athlete?.profile : form.values.profileId;

  const { data, isLoading } = useSalesPortalAthleteByProfile(packageData.gym.gymId, athleteProfileId);

  return {
    athleteProfile: data?.data,
    isLoading: !!athleteProfileId && isLoading,
    athleteProfileId,
  };
}
